export enum CallOutKind {
  INFO = 'info',
  WARNING = 'warning',
  ATTENTION = 'attention',
  RECOMMENDATION = 'recommendation',
}
